// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList
}                         from '../../../components';
import styles                 from './style';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import VenueInfo from '../VenueInfo';
import FixtureInfo from '../FixtureInfo';
import ExpenseInfo from '../ExpenseInfo';
import ReportsInfo from '../ReportsInfo';

class VenueDetails extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue: props.match.params.id,
      info_tab : true,
      fixture_tab: false,
      expense_tab: false,
      marketing_tab: false,
      reports_tab: false,
      data:[],
      loading: true
    };
    this.handleTab = this.handleTab.bind(this);

  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    this.getVenueDetails();
    // fetchEarningGraphDataIfNeeded();
    // fetchStatsCardDataIfNeeded();
    // fetchStatsTableDataIfNeeded();
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getVenueDetails(){
    console.log('getVenueDetails')
    console.log('venue_id',this.state.venue)
    const url = `${getLocationOrigin()}/get_venue_list/get_venue_details_for_cm/?venue=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
     .then(checkStatus)
     .then(parseJSON)
     .then(data => {
       if(data.success){
         this.setState({data:data.result,loading:false});
       }
       else{
        alert(data.message)
        window.location.href = `./#/venueLanding`
       }
     }).catch(error => error);
    }

  handleTab(event){
    const name = event.target.name
    if(name == 'venue_info'){
      this.setState({info_tab:true,fixture_tab:false,expense_tab:false,marketing_tab:false,reports_tab:false})
    }
    else if(name == 'fixture'){
      this.setState({fixture_tab:true,info_tab:false,expense_tab:false,marketing_tab:false,reports_tab:false})
    }
    else if(name == 'expense'){
      this.setState({expense_tab:true,info_tab:false,fixture_tab:false,marketing_tab:false,reports_tab:false})
    }
    else if(name == 'marketing'){
      this.setState({marketing_tab:true,info_tab:false,fixture_tab:false,expense_tab:false,reports_tab:false})
    }
    else if(name == 'reports'){
      this.setState({reports_tab:true,info_tab:false,fixture_tab:false,marketing_tab:false,expense_tab:false})
    }
  }

  render() {
    const venue = {'venue':this.state.venue}
    return(
      <div style={styles.container}>
        {this.state.loading === true ?
          <div style={{height:500}}>
            <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
          </div>
          :
          <div className='col-md-12' style={{padding:'0px',width:'100%'}}>
            <div className='col-md-12 ' style={styles.main_header}>
              <span className='col-md-1' style={styles.title} onClick={()=>{this.props.history.goBack();}}><i className="fa fa-arrow-left" style={{float:'left',marginTop:'6%',cursor:'pointer'}}/></span>
              <div className='col-md-9 label_blue_1' style={{padding:'0px'}}>
                <div className='col-md-11' style={styles.title}> {this.state.data.name} </div>
              </div>
              <div className='col-md-3' style={{color:'black',fontWeight:'600',padding:'5px',marginLeft:'1%',fontSize:'14px',display:'flex',flexDorection:'row'}}> 
                <div className="col-md-6">Status - </div>
                <div className="col-md-6">
                  <span className={this.state.data.status == 'Open' ? 'badge badge-success' : 'badge badge-danger'} style={{padding:'4px 8px', fontSize:'14px',letterSpacing:'1px',marginLeft:'3%'}}> 
                    {this.state.data.status} 
                  </span>
                </div>
              </div>
              <div className="col-md-1" >
                  <Link to={`../crud/editVenue/${this.state.venue}`}>
                    <button className='button1'>Edit</button>
                  </Link>
              </div>
            </div>

            <div className='col-md-12' style={styles.row}>
              <div className='col-md-4'>
                <span style={styles.bold_text}>Start Time - </span>
                <span>{this.state.data.start_time}</span>
              </div>
              <div className='col-md-4'>
                <span style={styles.bold_text}>City - </span>
                <span>{this.state.data.city}</span>
              </div>
              <div className='col-md-4'>
                <span style={styles.bold_text}>Active Users - </span>
                <span> - </span>
              </div>
            </div>

            <div className='col-md-12' style={styles.row}>
              <div className='col-md-4'>
                <span style={styles.bold_text}>End Time - </span>
                <span>{this.state.data.end_time}</span>
              </div>
              <div className='col-md-4'>
                <div className='col-md-3' >
                  <span style={styles.bold_text}>Location - </span>
                </div>
                <div className='col-md-9'>
                  <span>{this.state.data.full_address}</span>
                </div>
              </div>
              <div className='col-md-4' >
                <div className='col-md-4'>
                <span style={styles.bold_text}>Revenue - </span>
                </div>
                <div className='col-md-8'>
                <span style={{display:'flex',flexDorection:'row'}}>&#8377; {this.state.data.revenue}</span>
                </div>
              </div>
            </div>

            <div className='col-md-12' style={styles.row}>
              <div className='col-md-4'>
                <span style={styles.bold_text}>Started On - </span>
                <span> - </span>
              </div>
              <div className='col-md-4' style={{display:'flex',flexDorection:'row'}}>
                <div className='col-md-3' style={{padding:'0px'}}>
                  <span style={styles.bold_text}>Games - </span>
                </div> 
                <div className='col-md-9' style={{display:'grid'}}>
                {this.state.data.games.map((each,index)=>
                  <div>{each.game_name}</div>
                  )}
                </div>
              </div>
              <div className='col-md-4'>
                <span style={styles.bold_text}>Owner Share - </span>
                <span> - </span>
              </div>
            </div>

            <div className='col-md-12' style={styles.row}>
              <div className='col-md-4'>
                <div className='col-md-2' style={{padding:'0px'}}>
                <span style={styles.bold_text}>Partner - </span>
                </div> 
                <div>
                {this.state.data.partners.map((each,index)=>
                  <div className='col-md-9'>
                    <span>{each.name}</span>
                    <br></br>
                    <span>({each.number})</span>
                  </div>
                  )}
                </div>
              </div>
              <div className='col-md-4'>
                <span style={styles.bold_text}>Contact - </span>
                <span >{this.state.data.contact_no}</span>
              </div>
              <div className='col-md-4'>
                <span style={styles.bold_text}>Sporthood Share - </span>
                <span> - </span>
              </div>
            </div> 

            <div className='col-md-12' style={{marginTop:'3%',color:'#7d3cff',fontWeight:'600'}}>
              <ul className="nav nav-tabs nav-justified table_container1">
                <li className="active"><a data-toggle="tab" className='heading heading2' style={{cursor:'pointer',color:'#444'}} name='venue_info' onClick={this.handleTab}>Venue Info</a></li>
                {/*<li><a data-toggle="tab" className='heading heading2' style={{cursor:'pointer',color:'#444'}} name='marketing' onClick={this.handleTab}>Sales   &amp; Marketing</a></li>*/}
                {/*<li><a data-toggle="tab" className='heading heading2' style={{cursor:'pointer',color:'#444'}} name='fixture' onClick={this.handleTab}>Fixtures  &amp; Allocation </a></li>*/}
                <li><a data-toggle="tab" className='heading heading2' style={{cursor:'pointer',color:'#444'}} name='expense' onClick={this.handleTab}>Expenses</a></li>
               {/* <li><a data-toggle="tab" className='heading heading2' style={{cursor:'pointer',color:'#444'}} name='reports' onClick={this.handleTab}>Reports</a></li>*/}
              </ul>
            </div>

            <div className='col-md-12'>
            { 
              this.state.info_tab &&
              <VenueInfo venue={this.state.venue}/>
              }
            {
              this.state.fixture_tab &&
              <FixtureInfo venue={this.state.venue}/>
            }
            {
              this.state.expense_tab &&
              <ExpenseInfo venue={this.state.venue}/>
            }
            {
              this.state.marketing_tab &&
              <div> Not Implemented Yet </div>
            }
            {
              this.state.reports_tab &&
              <ReportsInfo venue={this.state.venue}/>
            }

            </div>
          </div>
        }
      </div>
    );
  }
}

export default VenueDetails;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/venueDetails/VenueDetails.js